// UX71 (docs/backlog.md): the floor's "Session & pricing debug" panel
// (index.html's #debug-panel; API base, tenant id, employee id, and other
// session-internal fields) used to render, one tap from open, for every
// user on every deployment, including stage0 and production -- exactly
// what CLAUDE.md's privacy rule and ordinary manager-facing copy both
// refuse to put in front of a person who is not debugging the app.
//
// The mechanism this repo already has for "is this local development":
// the SAME bundle is served everywhere (stage0, production, and a local
// dev/e2e run), so there is no compile-time flag distinguishing them; the
// one fact that differs is the HOSTNAME the page is actually loaded from.
// stage0 answers at stage0.snipsip.com and production at its own real
// domain; a local run answers at localhost, 127.0.0.1, the IPv6 loopback,
// or a name ending in .localhost or .test (the same loopback vocabulary
// CLAUDE.md's own "Testing the user's own application" rule already uses
// elsewhere in this shop's tooling). This repo's e2e harness
// (ui/staticServer.ts) always binds 127.0.0.1, so every existing floor/
// admin Playwright spec that asserts something about #debug-panel keeps
// seeing it, unchanged; only a real deployed hostname now hides it.
//
// A pure function, no DOM: testable directly from a plain node:test file
// (test/local-environment.test.ts), matching this codebase's own
// convention (see ui/src/money.ts, ui/src/strength.ts) for the UI's other
// hostname/window-free logic.
export function isLocalDevelopmentHost(hostname: string): boolean {
  const normalized = hostname.toLowerCase();
  return (
    normalized === "localhost" ||
    normalized === "127.0.0.1" ||
    normalized === "[::1]" ||
    normalized === "::1" ||
    normalized.endsWith(".localhost") ||
    normalized.endsWith(".test")
  );
}

/** UIFIX2 (SF-13, design/notes/console-design-fix-plan.md): staff never see the floor's "Session & pricing debug"
 * panel or the "Pricing: Shelf" pill. They appear only in diagnostics mode, which is asked for with `?diagnostics=1`
 * in the address or a `diagnostics` entry of "1" in this browser's local storage. Pure, no DOM. */
export function isDiagnosticsRequested(search: string, stored: string | null): boolean {
  return new URLSearchParams(search).get("diagnostics") === "1" || stored === "1";
}
